<template>
  <v-menu :key="event.id" v-model="event.open" full-width offset-x>

    <template v-slot:activator="{ on }">
      <v-sheet :style="getSheetStyle(event)" class="my-event" v-on="on">
        <div class="wrapper">
          <div class="marquee" refs="eventTetxt">
            <span :style="getEventTextStyle(event)">
              {{ event.title + ' ' + event.scheduledAt.split(' ')[1] }}
            </span>
          </div>
        </div>
      </v-sheet>
    </template>

    <v-card color="grey lighten-4" flat min-width="350px">
      <v-toolbar :color="getColor(event)" dark>
        <v-toolbar-title v-html="`${event.title}`"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="menuEventClick($event, on)">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="edit($event, event)">
              <v-list-tile-title>{{ $t('calendar.base.edit') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('show-history', this.event)">
              <v-list-tile-title>{{ $t('calendar.base.history') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteEvent(event)">
              <v-list-tile-title>{{ $t('calendar.base.delete') }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>

      <v-card-text>
        <div>
          {{ $t('calendar.base.start') }}: {{ event.scheduledAt }}<br>
          {{ $t('calendar.base.end') }}: {{ event.finishedAt }}
        </div>
        <v-divider></v-divider>
        <div style="margin:1rem 0rem;white-space: pre-line">
          {{ event.description }}
        </div>
        <v-dialog>
          <div v-if="event.event_data && event.event_data.form_id" slot="activator">
            <v-btn color="secondary" flat outline style="margin:0">
              Pokaż formularz
            </v-btn>
          </div>
          <div>
            <SingleView :form-id="event.event_data.form_id" :schema-id="event.event_data.schema_id"></SingleView>
          </div>
        </v-dialog>

        <v-divider></v-divider>
        <div style="white-space: pre-line">
          Uzytkownicy: {{ getUserNames(event.users) }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" flat>
          {{ $t('calendar.base.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>


<script>
import Messenger from "@/plugins/Messenger"
import SingleView from "@/components/form/SingleView.vue"


export default {
  components: {SingleView},
  props: ['event', 'top', 'height', 'useUserCalendarColor'],
  data() {
    return {}
  },
  created() {

  },
  methods: {
    edit($event, calendarEvent) {
      $event.stopPropagation()
      this.$router.push(`/calendar/${calendarEvent.id}/update`)
    },
    deleteEvent(calendarEvent) {
      this.$http.delete(`calendar/${calendarEvent.id}`).then(() => {
        this.$emit('delete-event', calendarEvent)
        Messenger.emitSuccess(this.$t('calendar.base.event_deleted'))
      }).catch(() => Messenger.emitError(this.$t('calendar.base.cannot_delete_event')))
    },
    getSheetStyle(event) {
      let color = this.getColor(event)
      let style = ` background-color: ${color};\n` +
          '  color: #ffffff;\n' +
          '  border: 1px solid black;'

      if (this.height > 0 && this.event.duration > 0) {
        style += `height:${this.height >= 20 ? this.height : 20}px;`
      }

      return style
    },
    menuEventClick($event, on) {
      $event.stopPropagation()
      on.click($event)
    },
    getEventTextStyle(event) {
      let color = this.getColor(event)
      let invertColor = this.invertColor(color, true)
      return `color:  ${invertColor};\n`
    },
    getUserNames(ids) {
      if (ids == null || !Array.isArray(ids)) {
        "Wszyscy"
      }

      if (!Array.isArray(this.$store.getters.users)) {
        return ""
      }

      let userNames = ""
      ids.forEach((id, key) => {
        let user = this.$store.getters.users.find(user => user.id == id)
        let prefix = key > 0 ? ", " : ""
        userNames += user != null ? (prefix + user.name + " " + user.surname) : "---"
      })
      return userNames
    },
    getColor(event) {
      if (this.useUserCalendarColor == true && event.event_data && event.event_data.user_color) {
        return event.event_data.user_color
      }

      if (event.event_data && event.event_data.color) {
        return event.event_data.color
      }

      return '#106011'
    },
    invertColor(hex, bw) {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1)
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      if (hex.length !== 6) {
        return '#000000'
      }
      var r = parseInt(hex.slice(0, 2), 16),
          g = parseInt(hex.slice(2, 4), 16),
          b = parseInt(hex.slice(4, 6), 16)
      if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF'
      }
      // invert color components
      r = (255 - r).toString(16)
      g = (255 - g).toString(16)
      b = (255 - b).toString(16)
      // pad each with zeros and return
      return "#" + String(r).padStart(2, 0) + String(g).padStart(2, 0) + String(b).padStart(2, 0)
    },
    getClass: function () {
      return 'marquee'
    },
  }
}
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px 2px;
  cursor: pointer;
  margin-bottom: 1px;
}

.wrapper {
  max-width: 100%;
  overflow: hidden;
  font-family: 'Times New Roman';
}

.marquee:hover {
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  animation: marquee 15s linear infinite;
}

.marquee p {
  display: inline-block;
}

@keyframes marquee {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(-65%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>